import { AuthenticationService } from 'app/services/data/authentication.service';
import { Component, OnInit, signal, WritableSignal, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MethodApi } from '../api/api-request';


@Component({
    selector: 'app-email-checker',
    templateUrl: './email-checker.component.html',
    styleUrls: ['./email-checker.component.scss'],
    standalone: false
})
export class EmailCheckerComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private api = inject(MethodApi);
    private router = inject(Router);
    private authenticationService = inject(AuthenticationService);

    isSuccess: boolean;
    isLoading: WritableSignal<boolean> = signal(true);
    private second: number = 3;

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.verifyEmail(params['userID'], params['verificationToken']);
        });
    }

    verifyEmail(userID: any, verificationToken: any) {
        this.authenticationService.verifyEmail({ userID: userID, token: verificationToken })
            .subscribe(
                data => {
                    this.isSuccess = data.verified;
                    this.isLoading.set(false);
                    if (this.isSuccess) {
                        this.redirect();
                    }
                },
                () => {
                    this.isLoading.set(false);
                    this.isSuccess = false;
                }
            );
    }

    private redirect(): void {
        let id = setInterval(() => {
            if (this.second === 0) {
                clearInterval(id);
                this.router.navigate(['login']);
            } else {
                this.second--;
            }
        }, 1000);
    }
}
